module.exports = __webpack_public_path__ + "media/images/restaurant/012_sushiya_zh_hant-4eb2e509e6530b64544978601fd1f32d.jpg";